var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifiedSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0065DF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.1,6.5 57,0.4 64.3,11.7 77.7,12.4 78.4,25.8 89.7,33.1 83.6,45.1 89.7,57 78.4,64.3 77.7,77.7  64.3,78.4 57,89.7 45.1,83.6 33.1,89.7 25.8,78.4 12.4,77.7 11.7,64.3 0.4,57 6.5,45.1 0.4,33.1 11.7,25.8 12.4,12.4 25.8,11.7  33.1,0.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,60.5L24.3,46.6c-0.7-0.6-0.7-1.7,0-2.3l1.9-2c0.6-0.7,1.7-0.7,2.3,0l10.3,9.9c0.6,0.6,1.7,0.6,2.3,0 l23.2-22.5c0.7-0.6,1.7-0.6,2.3,0l1.9,2c0.6,0.7,0.6,1.7,0,2.3L41.1,60.5C40.4,61.1,39.4,61.1,38.8,60.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSign);
export default __webpack_public_path__ + "static/media/verified_sign.7aff144940a62f9229e1c8741eb3316b.svg";
export { ForwardRef as ReactComponent };